import USBNotification from "@usb-shield/react-notification";
import ContactUs from "./ContactUs";

const ReportNotification = () => {
  return (
    <div className="mt-2">
      <USBNotification
        roleType="alert"
        status="danger"
        iconAssistiveText={{ label: "Error" }}
      >
        <strong>Notice</strong>: One or more of your dashboards are down for
        maintenance. We are working to resolve this, so please check back soon.
        <ContactUs />
      </USBNotification>
    </div>
  );
};

export default ReportNotification;
